export default function Footer() {
  return (
    <footer className="bg-[#080c17] text-white">
      <div className="max-w-7xl mx-auto px-8 pt-16 pb-8">
        <div className="grid md:grid-cols-5 gap-12 mb-16">
          <div className="md:col-span-2">
            <img
              src="https://static.readdy.ai/image/0fc33fa68f46f743570ad8ba1c3172ea/e2810a222c84ca6d6d2cab0352aac7a5.png"
              alt="Santislogix"
              className="h-[90px] w-[90px] object-contain mb-5 opacity-90"
            />
            <p className="text-sm text-white/40 leading-relaxed max-w-xs">
              Intelligent operational frameworks for high-trust service businesses that demand precision and excellence.
            </p>
            <div className="flex gap-3 mt-6">
              <a href="#linkedin" className="w-8 h-8 flex items-center justify-center rounded-full border border-white/10 text-white/40 hover:text-teal-400 hover:border-teal-400/30 transition-all cursor-pointer">
                <i className="ri-linkedin-fill text-sm" />
              </a>
              <a href="#twitter" className="w-8 h-8 flex items-center justify-center rounded-full border border-white/10 text-white/40 hover:text-teal-400 hover:border-teal-400/30 transition-all cursor-pointer">
                <i className="ri-twitter-x-fill text-sm" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold tracking-[0.15em] uppercase text-white/30 mb-5">Services</h4>
            <ul className="space-y-3">
              {['Our Approach', 'Industries', 'Summit Systems', 'Results'].map(item => (
                <li key={item}>
                  <a href={`#${item.toLowerCase().replace(/\s+/g, '-')}`} className="text-sm text-white/50 hover:text-white transition-colors cursor-pointer">{item}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold tracking-[0.15em] uppercase text-white/30 mb-5">Company</h4>
            <ul className="space-y-3">
              {['About Us', 'Case Studies', 'Contact', 'Careers'].map(item => (
                <li key={item}>
                  <a href={`#${item.toLowerCase().replace(/\s+/g, '-')}`} className="text-sm text-white/50 hover:text-white transition-colors cursor-pointer">{item}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold tracking-[0.15em] uppercase text-white/30 mb-5">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 shrink-0">
                  <i className="ri-mail-line text-xs text-teal-500" />
                </div>
                <span className="text-sm text-white/50">contact@santislogix.com</span>
              </li>
              <li className="flex items-start gap-2">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 shrink-0">
                  <i className="ri-map-pin-line text-xs text-teal-500" />
                </div>
                <span className="text-sm text-white/50">United States</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-white/25">© 2025 Santislogix. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <a href="#privacy" className="text-xs text-white/25 hover:text-white/60 transition-colors cursor-pointer">Privacy Policy</a>
            <a href="#terms" className="text-xs text-white/25 hover:text-white/60 transition-colors cursor-pointer">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
